var exports = {
  "Zd": "EmbedDebuggerTab.module__form___N0xYNz",
  "v1": "EmbedDebuggerTab.module__formControls___N0xYNz",
  "Wn": "EmbedDebuggerTab.module__urlField___N0xYNz",
  "Y2": "EmbedDebuggerTab.module__urlInput___N0xYNz",
  "RC": "EmbedDebuggerTab.module__submitButton___N0xYNz",
  "Xv": "EmbedDebuggerTab.module__results___N0xYNz",
  "KR": "EmbedDebuggerTab.module__embedPreview___N0xYNz",
  "Dy": "EmbedDebuggerTab.module__codeSurface___N0xYNz",
  "qS": "EmbedDebuggerTab.module__statusText___N0xYNz",
  "kc": "EmbedDebuggerTab.module__errorText___N0xYNz",
};

module.exports = exports;
